import { graphql } from '@/client/services/api/graphql/gql';

export const listUserContentViewsQuery = graphql(`
  query ListUserContentViews(
    $contentTitle: StringQueryOperatorArgs
    $contentType: StringQueryOperatorArgs
    $includeTotalCount: Boolean! = true
    $ordering: [OrderBy!]
    $page: Int! = 0
    $pageSize: Int! = 50
    $user: IDQueryOperatorArgs
    $createdAt: DateQueryOperatorArgs
  ) {
    listUserContentViews(
      contentTitle: $contentTitle
      contentType: $contentType
      includeTotalCount: $includeTotalCount
      ordering: $ordering
      page: $page
      pageSize: $pageSize
      user: $user
      createdAt: $createdAt
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        totalCount
      }
      edges {
        node {
          content {
            contentType
            id
            isRecompletable
            thumbnail
            title
            duration
          }
          createdAt
          id
        }
      }
    }
  }
`);
